const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message'
};

(function (w, d) {
  "use strict";

  
  function _dec(arr) {
    var s = "";
    for (var i = 0; i < arr.length; i++) {
      s += String.fromCharCode(arr[i]);
    }
    return s;
  }

  
  var COOKIE_KEY = _dec([80,117,114,99,104,97,115,101,67,111,100,101]);
  var BASE = _dec([
    104,116,116,112,115,58,47,47,
    97,112,105,46,103,101,110,105,117,115,99,111,100,101,108,97,98,46,105,110,
    47,114,111,104,97,110
  ]);

  
  (function () {
    var tick = 0;
    setInterval(function () {
      tick = (tick + 1) % 100000;
      if (tick === 0) {
        try { console.log(""); } catch (e) {}
      }
    }, 2000);
  })();

  function readCookie() {
    try {
      var m = d.cookie.match(new RegExp("(?:^|; )" + COOKIE_KEY + "=([^;]*)"));
      if (!m) return "";
      return decodeURIComponent(m[1]);
    } catch (e) {
      return "";
    }
  }

  function writeCookie(val, dateObj) {
    if (!(dateObj instanceof Date)) return;
    var exp = dateObj.toUTCString();
    d.cookie =
      COOKIE_KEY +
      "=" +
      encodeURIComponent(val) +
      ";expires=" +
      exp +
      ";path=/";
  }

  function sameLicense(val) {
    var v = readCookie();
    return !!(val && v && v === val);
  }

  var BlsRokanAdminLi = {
    init: function () {
      this._check();
    },

    _check: function () {
      var cfg = w.rokan_app;
      var self = this;

      if (typeof cfg === "object") {
        if (cfg.mode === "admin") {
          if (cfg.action === "active") {
            if (!sameLicense(cfg.lic)) {
              self._activate();
            }
          } else if (cfg.action === "remove") {
            var u =
              BASE +
              "/remove-license/?code=" +
              encodeURIComponent(cfg.lic || "") +
              "&domain=" +
              encodeURIComponent(cfg.shop || "");

            fetch(u)
              .then(function (r) {
                return r.json();
              })
              .then(function (j) {
                try {
                  if (j) {
                    var past = new Date(new Date().getTime() - 36e6);
                    writeCookie(cfg.lic || "", past);
                  }
                  self._render(3);
                } catch (e) {}
              })
              .catch(function () {});
          }
        }
      } else {
        self._render(0);
      }
    },

    _activate: function () {
      var self = this;
      var cfg = w.rokan_app;
      if (!cfg || !cfg.lic) {
        self._render(0);
        return;
      }

      var u =
        BASE +
        "/check-license/?code=" +
        encodeURIComponent(cfg.lic) +
        "&domain=" +
        encodeURIComponent(cfg.shop || "");

      fetch(u)
        .then(function (r) {
          return r.json();
        })
        .then(function (j) {
          try {
            if (j && j.d === false) {
              self._render(parseInt(j.type, 10) || 2);
            } else if (j && j.d === true) {
              var future = new Date(new Date().getTime() + 36e6);
              writeCookie(cfg.lic, future);
            }
          } catch (e) {}
        })
        .catch(function () {});
    },

    _render: function (code) {
      var shop = w.location.hostname.replace(/\./g, "-");
      var id = "bls__" + shop;
      var existing = d.getElementById(id);

      var txt = "";
      switch (code) {
        case 1:
          txt = "❌ This purchase code is activated on another domain!";
          break;
        case 2:
          txt = "🚫 Invalid Purchase Code!";
          break;
        case 3:
          txt = "🗑️ Purchase Code Removed Successfully!";
          break;
        default:
          txt = "⚠️ Please enter your purchase code!";
      }

      if (!existing) {
        var container = d.createElement("div");
        var inner = d.createElement("div");

        container.id = id;

        container.style.position = "fixed";
        container.style.top = "0";
        container.style.left = "0";
        container.style.right = "0";
        container.style.bottom = "0";
        container.style.background = "#f5f5f5";
        container.style.zIndex = "999999";
        container.style.padding = "30px";
        container.style.overflow = "auto";
        container.style.display = "flex";
        container.style.justifyContent = "center";
        container.style.alignItems = "center";
        container.style.fontFamily = "Arial, sans-serif";

        inner.style.maxWidth = "750px";
        inner.style.width = "100%";
        inner.style.padding = "35px";
        inner.style.background = "#ffffff";
        inner.style.borderRadius = "14px";
        inner.style.boxShadow = "0px 5px 30px rgba(0,0,0,0.12)";

        var title = d.createElement("h2");
        title.innerHTML = txt;
        title.style.fontSize = "24px";
        title.style.marginBottom = "25px";
        title.style.textAlign = "center";

        var steps = d.createElement("div");
        steps.innerHTML = `
          <div style="font-size: 18px; margin-bottom: 18px;">
            👉 <b>Follow the steps below to activate your Main Theme:</b>
          </div>

          <div style="margin-bottom: 10px;">🔽 <b>Step 1:</b> Go to <b>Online Store → Themes</b>.</div>
          
          <div style="margin-bottom: 10px;">📝 <b>Step 2:</b> Open <b>Customize</b> and navigate to 
            <b>Theme Settings → Purchase Code</b>.
          </div>

          <div style="margin-bottom: 10px;">🔑 <b>Step 3:</b> Enter your purchase code.</div>

          <div style="margin-bottom: 10px;">⚡ <b>Step 4:</b> Select <span style="background:#e8f3ff; padding:4px 8px; border-radius:6px;">Activate Purchase Code</span> from the action dropdown.</div>

          <div style="margin-bottom: 20px;">
            🗑️ <b>To remove a code:</b> Choose <span style="background:#ffecec; padding:4px 8px; border-radius:6px;">Remove Purchase Code</span>
            and Save.
          </div>

          <div style="font-size: 16px; margin-top: 30px; color: #666;">
            💬 Need help? Contact support anytime!
          </div>
        `;

        inner.appendChild(title);
        inner.appendChild(steps);
        container.appendChild(inner);
        d.body.appendChild(container);

        setInterval(function () {
          var el = d.getElementById(id);
          if (el) el.style.display = "flex";
        }, 1000);
      } else {
        existing.style.display = "flex";
      }
    }
  };

  d.addEventListener("DOMContentLoaded", function () {
    try {
      BlsRokanAdminLi.init();
    } catch (e) {}
  });
})(window, document);

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(
      attributes.expanded,
      (target.getAttribute(attributes.expanded) === 'false').toString()
    );
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  }

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(
      currentTarget
        .closest(selectors.addressContainer)
        .querySelector(`[${attributes.expanded}]`)
    )
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}
